import React, { createContext, useContext, useState, ReactNode } from 'react';

interface IPuntoServicioFiscalizacion {
  ps_codigo: string
}

interface Fiscalizacion {
  imagen?: string;
  rutinas?: string;
  procedimiento?: string;
}

interface IFDeposito {
  calificacion_id: number;
  calificacion?: string;
}
interface IFMaquinas {
  calificacion_id: number;
  maquina_codigo: string;
  maquina_descripcion: string;
  estado: number;
  origen: string;
}
export interface IFLP {
  id?:                    number;
  calificacion:           string;
  comentario:             string;
  acciones_correctivas?:  string;
  fecha?:                 string;
}
interface IFOpinion {
  calificacion_id: number;
}
interface IFStock {
  calificacion_id: number;
}

interface Operario {
  nombreOperario: string;
  tipo: string;
  calificacion: string;
  fiscalizacion?: Fiscalizacion[];
}

interface FiscalizacionContextType {
  informacionFiscalizacion: Operario[];
  setInformacionFiscalizacion: (info: any) => void;
  limpiarInformacionFiscalizacion: () => void; // Agregamos la función al tipo de contexto
  fiscalizacionDeposito: IFDeposito[];
  setInformacionFiscalizacionDeposito: (info: any) => void
  fiscalizacionMaquinas: IFMaquinas[];
  setInformacionFiscalizacionMaquinas: (info: any) => void
  fiscalizacionLP: IFLP[];
  setInformacionFiscalizacionLP: (info: any) => void
  fiscalizacionOpinion: IFOpinion[];
  setInformacionFiscalizacionOpinion: (info: any) => void
  fiscalizacionStock: IFStock[];
  setInformacionFiscalizacionStock: (info: any) => void
  puntoServicioFiscalizacion: IPuntoServicioFiscalizacion;
  setPuntoServicioFiscaliacion: (info: any) => void;
}

export const FiscalizacionContext = createContext<FiscalizacionContextType | undefined>(undefined);

export const FiscalizacionProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [informacionFiscalizacion, setInformacionFiscalizacionState] = useState<Operario[]>([]);
  const [fiscalizacionDeposito, setFiscalizacionStateDeposito] = useState<IFDeposito[]>([]);
  const [fiscalizacionMaquinas, setFiscalizacionStateMaquinas] = useState<IFMaquinas[]>([]);
  const [fiscalizacionLP, setFiscalizacionStateLP] = useState<IFLP[]>([]);
  const [fiscalizacionOpinion, setFiscalizacionStateOpinion] = useState<IFOpinion[]>([]);
  const [fiscalizacionStock, setFiscalizacionStateStock] = useState<IFStock[]>([]);
  const [puntoServicioFiscalizacion, setPuntoServicioFiscaliacionState] = useState<IPuntoServicioFiscalizacion>({ ps_codigo: '' });

  const setPuntoServicioFiscaliacion = (info: IPuntoServicioFiscalizacion | string) => {
    const normalizedInfo =
      typeof info === 'string'
        ? { ps_codigo: info }
        : { ps_codigo: String(info?.ps_codigo || '') };

    console.log(normalizedInfo, '=========> info');
    setPuntoServicioFiscaliacionState(normalizedInfo);
  };

  const setInformacionFiscalizacion = (info: Operario) => {
    setInformacionFiscalizacionState((prevState) => {
      const newState = [...prevState]; 
      const index = newState.findIndex((operario) => operario.nombreOperario === info.nombreOperario);
      
      if (index !== -1) {
        const existingOperario = newState[index];
        const existingFiscalizacion = existingOperario.fiscalizacion?.[0];

        const updatedFiscalizacion = {
          ...existingFiscalizacion,
          [info.tipo.toLowerCase()]: info.calificacion
        };

        newState[index] = {
          ...existingOperario,
          fiscalizacion: [updatedFiscalizacion],
        };
      } else {
        const newOperario: Operario = {
          ...info,
            fiscalizacion: [{
            imagen: '',
            rutinas: '',
            procedimiento: '',
            [info.tipo.toLowerCase()]: info.calificacion
          }]
        };
        
        newState.push(newOperario);
      }
      
      return newState;
    });
  };

  const limpiarInformacionFiscalizacion = () => {
    setInformacionFiscalizacionState([]);
  };

  const setInformacionFiscalizacionDeposito = (info: IFDeposito) =>{
    setFiscalizacionStateDeposito((prevState) => {
      const newCalification = [...prevState]
      const indexCalification = newCalification.findIndex((calification) => calification.calificacion_id === info.calificacion_id);
      if(indexCalification !== -1){
        const existingCalification = newCalification[indexCalification].calificacion_id[0];
        newCalification[indexCalification] = {
          ...existingCalification,
          calificacion: info.calificacion_id
        }
      } else {
        newCalification.push(info)
      }
      return newCalification
    })
  }
  const setInformacionFiscalizacionMaquinas = (info: IFMaquinas) => {
    setFiscalizacionStateMaquinas((prevState) => {
      const newState = [...prevState];
      const index = newState.findIndex((maquina) => maquina.maquina_codigo === info.maquina_codigo);
      if (index !== -1) {
        newState[index] = {
          ...newState[index]
        };
      } else {
        newState.push(info);
      }

      console.log(newState, '=========> newState');
      
      return newState;
    });
  };
  const setInformacionFiscalizacionLP = (info: IFLP) => {
    setFiscalizacionStateLP((prevState) => {
      const newValueLP = prevState;
      const indexValueLP = newValueLP.findIndex((calificacion) =>{ 
        return calificacion.id === info.id});
      if (indexValueLP !== -1) {
        newValueLP[indexValueLP] = info;
      } else {
        newValueLP.push(info);
      }
      return newValueLP;
    });
  };
  const setInformacionFiscalizacionOpinion = (info: IFOpinion) =>{
    setFiscalizacionStateOpinion((prevState) => {
      const newCalification = [...prevState]
      const indexCalification = newCalification.findIndex((calification) => calification.calificacion_id === info.calificacion_id);
      if(indexCalification !== -1){
        newCalification[indexCalification] = {
          ...newCalification[indexCalification],
          ...info,
        }
      } else {
        newCalification.push(info)
      }
      return newCalification
    })
  }
  const setInformacionFiscalizacionStock = (info: IFStock) =>{
    setFiscalizacionStateStock((prevState) => {
      const newValueStock = prevState;
      const indexValueStock = newValueStock.findIndex((calificacion) =>{
        return calificacion.calificacion_id === info.calificacion_id});
      if (indexValueStock !== -1) {
        newValueStock[indexValueStock] = info;
      } else {
        newValueStock.push(info);
      }
      return newValueStock;
    });
  }

  return (
    <FiscalizacionContext.Provider value={{
      puntoServicioFiscalizacion, 
      setPuntoServicioFiscaliacion,
      informacionFiscalizacion, 
      setInformacionFiscalizacion, 
      limpiarInformacionFiscalizacion, 
      fiscalizacionDeposito, 
      setInformacionFiscalizacionDeposito,
      fiscalizacionMaquinas,
      setInformacionFiscalizacionMaquinas,
      fiscalizacionLP,
      setInformacionFiscalizacionLP,
      fiscalizacionOpinion,
      setInformacionFiscalizacionOpinion,
      fiscalizacionStock,
      setInformacionFiscalizacionStock }}>
      {children}
    </FiscalizacionContext.Provider>
  );
};

export const useFiscalizacion = (): FiscalizacionContextType => {
  const context = useContext(FiscalizacionContext);
  if (!context) {
    throw new Error('useFiscalizacion must be used within a FiscalizacionProvider');
  }
  return context;
};
